/**
 * Full-viewport hero section for the landing page.
 *
 * Displays a background stock image with a gradient overlay,
 * headline, subheadline, and a CTA button linking to plan discovery.
 * All text is sourced from the `landing` i18n namespace.
 *
 * @module landing/sections/HeroSection
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer } from '../../../shared/src/responsive/ResponsiveContainer';
import { LANDING_IMAGES } from '../content/images';

/**
 * Hero section with background image, gradient overlay, and CTA.
 */
export function HeroSection(): React.JSX.Element {
  const { t } = useTranslation('landing');

  return (
    <section className="landing-hero">
      <div
        className="landing-hero__background"
        style={{ backgroundImage: `url(${LANDING_IMAGES.hero})` }}
      />
      <div className="landing-hero__overlay" />
      <ResponsiveContainer>
        <div className="landing-hero__content">
          <h1 className="landing-hero__headline">
            {t('hero.headline')}
          </h1>
          <p className="landing-hero__subheadline">
            {t('hero.subheadline')}
          </p>
          <a href="/public-discovery/plans" className="ipa-btn ipa-btn--cta">
            {t('hero.cta')}
          </a>
        </div>
      </ResponsiveContainer>
    </section>
  );
}
